import { render, staticRenderFns } from "./FormUploader.vue?vue&type=template&id=98d4114a"
import script from "./FormUploader.vue?vue&type=script&lang=ts"
export * from "./FormUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports